<template>
  <div class="col text-center fadein-details">
    <div v-if="reason" class="row">
      <div class="col p-3">
        {{ reason }}
      </div>
    </div>
    <div class="row">
      <div class="col m-2">
        <b-button variant="primary" size="sm" @click="reason=null; $emit('close')">
          {{ $t('Close') }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import {NOT_AVAILABLE} from "@/store/leads/mutation-types";

export default {
  name: "NotAvailable",
  computed: {
    reason: {
      get: function() {
        return this.$store.state.leads.NOT_AVAILABLE[0];
      },
      set: function (value) {
        this.$store.commit(NOT_AVAILABLE, value);
      }
    }
  }
}
</script>

<style scoped>

</style>
